import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import { SarlaftOperationInternationalProps } from './props';
import { useSarlaftOperationInternational } from './hook';

export const SarlaftOperationInternational = (
    props: SarlaftOperationInternationalProps
) => {
    const { formik } = useSarlaftOperationInternational(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Actividad en operaciones internacionales
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="¿Realiza transacciones en moneda extranjera?"
                    checked={Boolean(formik.values.foreignCurrencyTransactions)}
                    onChange={() => {
                        formik.setFieldValue(
                            'foreignCurrencyTransactions',
                            !formik.values.foreignCurrencyTransactions
                        );
                    }}
                    onBlur={formik.handleBlur}
                    errors={formik.errors.foreignCurrencyTransactions}
                />
            </Grid>
            {formik.values.foreignCurrencyTransactions && (
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="¿Cuál?"
                        name="whichCurrencyTransactions"
                        size="small"
                        onBlur={formik.handleBlur}
                        touched={formik.touched.whichCurrencyTransactions}
                        errors={formik.errors.whichCurrencyTransactions}
                        value={formik.values.whichCurrencyTransactions}
                        onChange={formik.handleChange}
                    />
                </Grid>
            )}
            <Grid item xs={12}>
                <FieldText
                    label="Otras operaciones"
                    name="otherOperations"
                    rows={6}
                    onBlur={formik.handleBlur}
                    value={formik.values.otherOperations}
                    onChange={formik.handleChange}
                    errors={formik.errors.otherOperations}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="¿Posee productos financieros en el exterior?"
                    checked={Boolean(formik.values.financialProductsAbroad)}
                    onChange={() => {
                        formik.setFieldValue(
                            'financialProductsAbroad',
                            !formik.values.financialProductsAbroad
                        );
                    }}
                    onBlur={formik.handleBlur}
                    errors={formik.errors.financialProductsAbroad}
                />
            </Grid>
            {formik.values.financialProductsAbroad && (
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="¿Cuál?"
                        name="whichProductsAbroad"
                        size="small"
                        onBlur={formik.handleBlur}
                        touched={formik.touched.whichProductsAbroad}
                        errors={formik.errors.whichProductsAbroad}
                        value={formik.values.whichProductsAbroad}
                        onChange={formik.handleChange}
                    />
                </Grid>
            )}
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="¿Posee cuentas en moneda extranjera?"
                    checked={Boolean(formik.values.foreignCurrencyAccounts)}
                    onChange={() => {
                        formik.setFieldValue(
                            'foreignCurrencyAccounts',
                            !formik.values.foreignCurrencyAccounts
                        );
                    }}
                    onBlur={formik.handleBlur}
                    errors={formik.errors.foreignCurrencyAccounts}
                />
            </Grid>
        </Grid>
    );
};
